/* eslint-disable @typescript-eslint/naming-convention */

import { SerializedMeter, createFullOBIS } from '@enmon/commons/lib/enmon';
import { isConsumptionRegister } from '@enmon/commons';
import type { ServiceInspectionFormValues } from '../components/Content';

export const getInitialServiceInspectionFormState = (
  enmonMeter?: SerializedMeter | null,
): ServiceInspectionFormValues => {
  const { registers } = enmonMeter ?? {};

  return {
    registerStates: (registers ?? [])
      .filter(isConsumptionRegister)
      .map(({ _id, name, unit, medium, obis, tariff }) => ({
        _id,
        name: name ?? '',
        unit,
        ...(medium && obis ? { fullObis: createFullOBIS({ medium, obis, tariff }) } : {}),
        photos: [],
      })),
    internalNote: '',
    placementOverviewPhotos: [],
  };
};
